import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DemoLandingComponent } from './ui-whitelabel-demo/demo-landing/demo-landing.component';
import { LauncherComponent } from './ui-landing/launcher/launcher.component';
import { ApplicantLandingComponent } from './ui-landing/applicant-landing/applicant-landing.component';
import { ApplicantLearnmoreComponent } from './ui-landing/applicant-learnmore/applicant-learnmore.component';
import { ProctorLandingComponent } from './ui-landing/proctor-landing/proctor-landing.component';
import { ProctorLearnmoreComponent } from './ui-landing/proctor-learnmore/proctor-learnmore.component';
import { CreateArticlesComponent } from './ui-landing/create-articles/create-articles.component';
import { NewsComponent } from './ui-landing/news/news.component';
import { LoginComponent } from './ui-landing/login/login.component';
import { ContactusComponent } from './ui-landing/contactus/contactus.component';
import { LegalComponent } from './ui-landing/legal/legal.component';
import { PrivacyComponent } from './ui-landing/privacy/privacy.component';
import { SampleQuestionsPreComponent } from './ui-landing/sample-questions-pre/sample-questions-pre.component';
import { SampleQuestionsComponent } from './ui-testrunner/sample-questions/sample-questions.component';
import { ViewCreateAccountComponent } from './ui-testadmin/view-create-account/view-create-account.component';
import { ViewDashboardComponent } from './ui-testadmin/view-dashboard/view-dashboard.component';
import { ViewMngInstInfoComponent } from './ui-testadmin/view-mng-inst-info/view-mng-inst-info.component';
import { ViewMngInstAccountsComponent } from './ui-testadmin/view-mng-inst-accounts/view-mng-inst-accounts.component';
import { ViewAllTestSessionsComponent } from './ui-testadmin/view-all-test-sessions/view-all-test-sessions.component';
import { ViewCtsTestWindowComponent } from './ui-testadmin/view-cts-test-window/view-cts-test-window.component';
import { ViewCtsLocationComponent } from './ui-testadmin/view-cts-location/view-cts-location.component';
import { ViewCtsTechreadyComponent } from './ui-testadmin/view-cts-techready/view-cts-techready.component';
import { ViewCtsDatestimesComponent } from './ui-testadmin/view-cts-datestimes/view-cts-datestimes.component';
import { ViewCtsAccommodationsComponent } from './ui-testadmin/view-cts-accommodations/view-cts-accommodations.component';
import { ViewCtsRestrictedComponent } from './ui-testadmin/view-cts-restricted/view-cts-restricted.component';
import { ViewCtsMakeAvailableComponent } from './ui-testadmin/view-cts-make-available/view-cts-make-available.component';
import { ViewCtsInvitiationsComponent } from './ui-testadmin/view-cts-invitiations/view-cts-invitiations.component';
import { ViewManageSessionComponent } from './ui-testadmin/view-manage-session/view-manage-session.component';
import { ViewPendingAccommComponent } from './ui-testadmin/view-pending-accomm/view-pending-accomm.component';
import { LogoutComponent } from './ui-landing/logout/logout.component';
import { ForgotPasswordComponent } from './ui-landing/forgot-password/forgot-password.component';
import { IAccountType } from './constants/account-types';
import { UiTransDbComponent } from './ui-trans/ui-trans-db/ui-trans-db.component';
import { UiTransAccountsComponent } from './ui-trans/ui-trans-accounts/ui-trans-accounts.component';
import { ViewInvigComponent } from './ui-testadmin/view-invig/view-invig.component';
import { ViewPrintApplicantsComponent } from './ui-testadmin/view-print-applicants/view-print-applicants.component';


const routes: Routes = [
  
  // Admin

  // { path: 'edit', component: CreateArticlesComponent },
  { path: 'translators', component: UiTransAccountsComponent },
  { path: 'lang', component: UiTransDbComponent },
  { path: 'lang/:filters', component: UiTransDbComponent },
  // { path: 'admin', component: UiTransDbComponent },

  // User Journeys

  { path: '', component: LauncherComponent },
  { path: ':lang/news', component: NewsComponent },
  { path: ':lang/contact', component: ContactusComponent },
  { path: ':lang/legal', component: LegalComponent },
  { path: ':lang/privacy', component: PrivacyComponent },
  { path: ':lang/applicant/landing', component: ApplicantLandingComponent },
  { path: ':lang/applicant/learn', component: ApplicantLearnmoreComponent },
  { path: ':lang/applicant/learn/:topicPath', component: ApplicantLearnmoreComponent },
  { path: ':lang/testadmin/landing', component: ProctorLandingComponent },
  { path: ':lang/testadmin/learn', component: ProctorLearnmoreComponent },
  { path: ':lang/testadmin/learn/:topicPath', component: ProctorLearnmoreComponent },
  { path: ':lang/sample-questions-pre', component: SampleQuestionsPreComponent },
  { path: ':lang/sample-questions', component: SampleQuestionsComponent },

  { path: `:lang/${IAccountType.TEST_ADMIN}/create-account`, component: ViewCreateAccountComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/dashboard`, component: ViewDashboardComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/mng-inst-info`, component: ViewMngInstInfoComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/mng-inst-accounts`, component: ViewMngInstAccountsComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/all-test-sessions`, component: ViewAllTestSessionsComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/create-test-sessions/:setupId/test-window`, component: ViewCtsTestWindowComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/create-test-sessions/:setupId/location`, component: ViewCtsLocationComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/create-test-sessions/:setupId/technical-readiness`, component: ViewCtsTechreadyComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/create-test-sessions/:setupId/dates-times`, component: ViewCtsDatestimesComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/create-test-sessions/:setupId/accommodations`, component: ViewCtsAccommodationsComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/create-test-sessions/:setupId/restricted`, component: ViewCtsRestrictedComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/create-test-sessions/:setupId/make-available`, component: ViewCtsMakeAvailableComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/create-test-sessions/:setupId/invitations`, component: ViewCtsInvitiationsComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/manage-session/:sessionId`, component: ViewManageSessionComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/print-session/:sessionId`, component: ViewPrintApplicantsComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/invigilate/:sessionId`, component: ViewInvigComponent, /*canActivate: [AuthGuard]*/ },
  { path: `:lang/${IAccountType.TEST_ADMIN}/pending-accomm/:institutionId`, component: ViewPendingAccommComponent, /*canActivate: [AuthGuard]*/ },


  { path: ':lang/test-admin/login', component: LoginComponent },
  { path: ':lang/test-admin/register', component: ViewCreateAccountComponent },
  { path: ':lang/logout', component: LogoutComponent },
  { path: ':lang/forgot-password', component: ForgotPasswordComponent },
  

  // whitelabel landings
  // { path: 'demo-landing', component: DemoLandingComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
